import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import { currentTenantSelector } from 'features/authentication';

import {
  currentAssetSelector,
} from 'redux/assets/selectors';
import { userProfileSelector } from 'redux/user/selectors';

import immutableToJS from 'utils/immutableToJS';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function WithConnectedData(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  WithConnectedData.propTypes = {
    assetInfo: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
    tenant: PropTypes.string.isRequired,
    userProfile: PropTypes.shape({
      companyId: PropTypes.string,
    }).isRequired,
  };

  function mapStateToProps(state) {
    return {
      assetInfo: currentAssetSelector(state),
      tenant: currentTenantSelector(state),
      userProfile: userProfileSelector(state),
    };
  }

  return compose(
    setDisplayName('CaseClassicAssetDetailButton'),
    connect(mapStateToProps),
    immutableToJS,
  )(WithConnectedData);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/CaseClassicAssetDetailButton/Container.js